import { OrderSummary, OrderType } from "../../data/interfaces";
import { RiEBike2Line } from "react-icons/ri";
import { IoBagHandle } from "react-icons/io5";
import classNames from "classnames";

const OrderSummaryCard: React.FC<{
  order: OrderSummary;
  selectOrder: (orderId: string) => void;
  isSelected?: boolean;
}> = ({ order, selectOrder, isSelected }) => {
  const handleSelectOrder = () => {
    selectOrder(order._id);
  };

  return (
    <div
      className={classNames(
        "flex p-4 justify-between items-center cursor-pointer transition-colors border-l-4 hover:bg-red-50",
        {
          "bg-white border-transparent": !isSelected,
          "bg-red-50 border-primary shadow-sm": isSelected,
        }
      )}
      onClick={handleSelectOrder}
    >
      <div className="flex gap-3 items-center">
        <div
          className={classNames(
            "rounded-lg p-2 w-12 h-12 flex items-center justify-center",
            {
              "bg-blue-100 text-blue-600":
                order.orderType === OrderType.DELIVERY,
              "bg-orange-100 text-orange-600":
                order.orderType !== OrderType.DELIVERY,
            }
          )}
        >
          {order.orderType === OrderType.DELIVERY ? (
            <RiEBike2Line className="w-6 h-6" />
          ) : (
            <IoBagHandle className="w-6 h-6" />
          )}
        </div>
        <div className="flex flex-col">
          <span className="font-bold text-gray-800">#{order.displayId}</span>
          <span className="text-sm text-gray-500">
            {order.orderType === OrderType.DELIVERY
              ? "Livraison"
              : "À emporter"}
          </span>
        </div>
      </div>

      <div className="flex flex-col text-right">
        <div className="font-bold text-gray-800">
          {order.paymentInfo.orderPrice.text}
        </div>
        <div className="text-sm text-gray-500">
          {`${order.items} ${order.items > 1 ? "produits" : "produit"}`}
        </div>
        <div className="text-xs text-gray-400 mt-1">
          {order.createdAt.slice(-5)}
        </div>
      </div>
    </div>
  );
};

export default OrderSummaryCard;
